import React, {Component} from 'react';
import HeaderComponent
    from "../../../Components/HeaderComponent/HeaderComponent";
import {Typography} from "@material-ui/core";
import ActionCardComponent
    from "../../../Components/ActionCardComponent/ActionCardComponent";
import {ContentMainStyled} from "./styled";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";
import LoginScreen from "../../CommonAccess/LoginScreen/LoginScreen";
import CreateMensageriaScreen from "./create/CreateMensageriaScreen";
import HistoryMensageriaScreen from "./history/HistoryMensageriaScreen";


class MensageriaScreen extends Component {
    static ROUTE = '/mensageria';

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            erros: [],
        };

    }

    render() {
        return (
            <>
                <HeaderComponent title={'Mensageria'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                <Typography align={'center'}
                            variant={'h6'}
                            color={'primary'}>
                    Escolha o que gostaria de fazer na Mensageria
                </Typography>
                <SpacerComponent height={80}/>

                <ContentMainStyled>
                    <ActionCardComponent
                        icon="📁" // Pode passar um emoji, imagem <img /> ou SVG
                        title={`Histórico\nde Envios`}
                        variant="light"
                        onClick={() => window.location.href = HistoryMensageriaScreen.ROUTE}
                        infoText={'Informações sobre Criar Nova Mensagem'}
                    />

                    <ActionCardComponent
                        icon="✉️"
                        title={`Criar\nNova Mensagem`}
                        variant="dark"
                        onClick={() => window.location.href = CreateMensageriaScreen.ROUTE}
                        infoText={'Informações sobre Criar Nova Mensagem'}
                    />
                </ContentMainStyled>


            </>
        );
    }
}

MensageriaScreen.propTypes = {};

export default MensageriaScreen;